import React, { useCallback, useEffect, useState } from 'react';
import './LifelineOrderDetailsV1.scss';
import { Loader, Modal } from '../../../../UiKit';
import { getCurrentTime } from '../../../../utils/CurrentTime';
import { ActionsView } from '../../../widgets';
import { CallLogs } from '../../../popups';
import {
  ORDER_EVENTS,
  sendOrderModalEvents,
  sendReloadOrderEvent,
} from '../../../../helpers/analytics/order.analytics';
import { TransactionsDetailsV2 } from '../../../popups/TransactionsDetails/TransactionDetailsV2';
import { LifelineOrderInfo } from './LifelineOrderInfo';
import { useSelector } from 'react-redux';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../../analytics/constants';
import {
  helpDeskOpenedEvent,
  popUpClosedEvent,
  popUpOpenendEvent,
} from '../../../../analytics/events';

let timerID = null;

export const LifelineOrderDetailsV1 = (props) => {
  const {
    order = null,
    activeOrderId = null,
    userId = null,
    cartId = null,
    orderInfo = null,
    isOrderShimmer,
    mapInfo,
    isWFH,
    issueSubmission,
    isTimelineUpdated,
    setIsTimelineUpdated,
    refundWarning,
    getOrderBasicInfo = () => {},
    setOpenHelpSection = () => {},
    setHelpDSectionOrderId = () => {},
  } = props;

  const curentTime = getCurrentTime();
  const [isLoading, setLoading] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [orderId, setOrderId] = useState(activeOrderId);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(curentTime);
  const [isTimeOut, setIsTimeOut] = useState(false);
  const [transactionDetails, setTransactiondetails] = useState();

  const idsForJumboEvents = {
    [MetricsForJumboEvent.order_id]: order?.order?.order_id,
    [MetricsForJumboEvent.customer_id]: userId,
    [MetricsForJumboEvent.cart_id]: cartId,
  };

  const isActionViewClose = useSelector((state) => {
    return state.basicOrderState?.isActionViewClose;
  }); // Ensure correct state mapping

  const orderBasicInfo =
    orderId && orderInfo && orderInfo[orderId] ? orderInfo[orderId] : null;

  const isLogOrder =
    orderBasicInfo &&
    orderBasicInfo.order &&
    orderBasicInfo.order.zomato_fulfilled
      ? true
      : false;

  let customClass = order?.selected_order ? 'borderRed' : '';

  useEffect(() => {
    if (orderId) {
      getOrderBasicInfo(orderId, userId);
    }
    return () => {
      clearTimeout(timerID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const updateTime = setTimeout(() => {
      setIsTimeOut(true);
    }, 300000);
    return () => {
      clearTimeout(updateTime);
    };
  }, [isTimeOut, lastUpdatedAt]);

  const reloadOrder = useCallback(
    (order_id) => {
      sendReloadOrderEvent(order_id, userId);
      setLoading(true);
      timerID = setTimeout(() => {
        getOrderBasicInfo(order_id, userId);
        setLoading(false);
      }, 500);
    },
    [userId, getOrderBasicInfo],
  );

  const getTransactionsDetails = useCallback(
    (isReportIssue) => {
      const source = isReportIssue ? 'Report an Issue' : '';
      popUpOpenendEvent({
        event_type: EventType.CLICK,
        feature_name: FeatureName.TRANSACTIONS,
        [MetricsForJumboEvent.order_id]: orderId,
        [MetricsForJumboEvent.customer_id]: userId,
        [MetricsForJumboEvent.cart_id]: cartId,
        source: String(source),
      });
      let details = {
        show: true,
        title: 'Transaction Details',
        size: 'large',
        showScrollBar: true,
        paddingTop: 0,
        maxHeight: '60vh',
        titleStyle: {
          fontSize: '17px',
          fontWeight: '800',
          marginLeft: '-0.4rem',
        },
        padding: 0,
        containerStyles: { margin: '16px 0 20px 0', padding: '0 20px' },
        component: (
          <TransactionsDetailsV2
            cartId={cartId}
            orderId={orderId}
            customerId={userId}
            transactionDetails={transactionDetails}
          />
        ),
        popUpType: FeatureName.TRANSACTIONS,
      };
      setPopupData(details);
    },
    [orderId, userId, cartId, transactionDetails],
  );

  const setTransactionDetails = useCallback((transactiondetails) => {
    setTransactiondetails(transactiondetails);
  }, []);

  // to be removed in report issue section refactoring
  const handleReportIssueCardLink = useCallback(() => {
    getTransactionsDetails(true);
  }, [getTransactionsDetails]);

  const closeModal = useCallback(() => {
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: popupData?.popUpType,
      ...idsForJumboEvents,
    });
    sendOrderModalEvents(ORDER_EVENTS.ORDER_MODAL_CLOSE, orderId, userId);
    setPopupData(null);
  }, [orderId, userId]);

  const openCallLogsModal = useCallback(() => {
    popUpOpenendEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.CALL_LOGS,
      ...idsForJumboEvents,
    });
    setPopupData({
      show: true,
      title: 'Call History',
      component: <CallLogs orderId={orderId} userId={userId} />,
      size: 'huge',
      maxHeight: '80vh',
      padding: 0,
      popUpType: FeatureName.CALL_LOGS,
      paddingTop: '1rem',
      containerStyles: { margin: '16px 0 0px 0', padding: '0 20px' },
    });
  }, [orderId, userId]);

  const openHelpSectionPopUp = useCallback(() => {
    setHelpDSectionOrderId(order?.order?.order_id);
    setOpenHelpSection(true);
    helpDeskOpenedEvent({
      [MetricsForJumboEvent.order_id]: orderId,
    });
  }, [setHelpDSectionOrderId, setOpenHelpSection, order, orderId]);

  return (
    <div className={`lifelineDetailContainerV1 ${customClass}`}>
      {isLoading ? (
        <div className='individualOrderloader'>
          <Loader />
        </div>
      ) : (
        <div className='orderDetailWrapper'>
          <LifelineOrderInfo
            issueSubmission={issueSubmission}
            orderId={orderId}
            userId={userId}
            cartId={cartId}
            mapInfo={mapInfo}
            orderInfo={orderInfo}
            isWFH={isWFH}
            isTimeOut={isTimeOut}
            lastUpdatedAt={lastUpdatedAt}
            isOrderShimmer={isOrderShimmer}
            refundWarning={refundWarning}
            getOrderBasicInfo={getOrderBasicInfo}
            orderBasicInfo={orderBasicInfo}
            reloadOrder={reloadOrder}
            openHelpSectionPopUp={openHelpSectionPopUp}
            openCallLogsModal={openCallLogsModal}
            getTransactionsDetails={getTransactionsDetails}
            setTransactionDetails={setTransactionDetails}
            setIsTimeOut={setIsTimeOut}
            setLastUpdatedAt={setLastUpdatedAt}
            getCurrentTime={getCurrentTime}
            isShowCalls={isLogOrder}
          />
          <div
            className={`reportIssueWrapper tw-duration-300 tw-ease-in-out ${
              isActionViewClose ? 'tw-w-28' : 'tw-w-[380px]'
            }`}
          >
            <ActionsView
              orderId={orderId}
              cartId={cartId}
              userId={userId}
              isTimelineUpdated={isTimelineUpdated}
              setIsTimelineUpdated={setIsTimelineUpdated}
              handleCardLink={handleReportIssueCardLink}
            />
          </div>
        </div>
      )}

      <Modal
        isVisible={popupData?.show}
        type={popupData?.size}
        title={
          popupData?.title ? (
            popupData?.titleStyle ? (
              <div style={popupData.titleStyle}>{popupData.title}</div>
            ) : (
              <>{popupData.title}</>
            )
          ) : null
        }
        maxHeight={popupData?.maxHeight}
        minHeight={popupData?.minHeight}
        handleClose={closeModal}
        component={popupData?.component}
        showScrollBar={popupData?.showScrollBar}
        paddingTop={popupData?.paddingTop}
        padding={popupData?.padding}
        containerStyles={popupData?.containerStyles}
      />
    </div>
  );
};
